import React from "react";

import './LogInProgress.css'

export function LogInProgress(props : {progress: number, data: string}) {
    const fillBarStyle = {
        height: '100%',
        width: `${props.progress > 0 ? props.progress * 25 : 0}%`,
        background: "var(--color-main)",
        transition: "0.2s"
    }

    const progressbar = <div className="flex-center"><div className="progress-bar login-wide">
            <div className="progress-bar-background flex-left" style={{backgroundColor: "var(--progress-bar-button-bg)"}}>
                <div className="progress-bar-button-fill" style={fillBarStyle}/>
            </div>
        </div>
    </div>

    return <div className="login-progress flex-center">
        <div/>
        <span className="font-white big-font"> {props.data} </span>
        {progressbar}
        <div/>
    </div>
}